export const calculateSugarFromCarbs = (carbs: number) => Math.round(carbs * 0.2);
